<aside class="rounded-2xl bg-white border border-gray-200 p-6 space-y-6">
  <h2 class="text-2xl font-extrabold mb-6 text-gray-900 tracking-tight">Profile</h2>
  <div class="flex justify-center">
    <!-- Hidden file input -->
    <input
      type="file"
      #fileInput
      accept="image/*"
      hidden
      (change)="onImageSelected($event)"
    />

    <!-- Clickable div for profile picture -->
    <div
      class="w-48 h-48 sm:w-56 sm:h-56 cursor-pointer border-2 border-gray-200 rounded-2xl overflow-hidden hover:border-[var(--primary)] transition-all duration-300 relative group flex items-center justify-center bg-gray-50"
      (click)="fileInput.click()"
    >
      <img
        *ngIf="(selectedImage || profilePicture) && !hasImageError"
        [src]="selectedImage ? selectedImage : profilePicture"
        (error)="onImageError()"
        alt="Profile Picture"
        class="w-full h-full object-cover rounded-2xl group-hover:scale-105 transition-transform duration-300"
      />
      <div
        *ngIf="!(selectedImage || profilePicture) || hasImageError"
        class="flex flex-col items-center justify-center text-gray-400 group-hover:scale-105 transition-transform duration-300 w-full h-full bg-gray-50"
      >
        <svg class="w-20 h-20" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
        </svg>
      </div>
      <div class="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center text-white text-xs font-bold uppercase tracking-wider">
        Change Image
      </div>
    </div>
  </div>

  <!-- Bottom Info -->
  <div class="text-center mt-4 space-y-2 text-sm">
    <!-- Joined Date -->
    <div class="text-gray-600">
      <span class="font-bold text-gray-800">Joined:</span>
      <span class="ml-1">
        {{ createdAt | date : "mediumDate" }}
      </span>
    </div>

    <!-- Email Verification -->
    <div
      class="flex justify-center items-center gap-1.5 font-bold"
      [ngClass]="emailVerified ? 'text-emerald-600' : 'text-rose-600'"
    >
      <ng-container *ngIf="emailVerified; else notVerified">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-5 h-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M5 13l4 4L19 7"
          />
        </svg>
        <span>Verified Account</span>
      </ng-container>

      <ng-template #notVerified>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-5 h-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <span>Unverified Account</span>
      </ng-template>
    </div>
  </div>
</aside>
